var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lg:text-2xl bg-primary font-heading flex-inline md:mr-auto lg:mr-6 md:mb-4 lg:mb-0 px-6 py-2 mr-3 text-xl italic font-medium text-white uppercase"},[_vm._v("\n    "+_vm._s(_vm.$t('tagline'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }